export default __webpack_public_path__ + "static/media/2013.cdf4ef59.png";